import React, { useState, useEffect, useContext } from 'react';
import { generateActivity } from '../utils/landingHelpers';
import { Alert } from 'react-bootstrap';
import { PersonFill, GeoAltFill } from 'react-bootstrap-icons';
import { AppContext } from '../../window';
import { useTranslation } from '../../i18n';

interface Activity {
    name: string;
    city: string;
    action: string;
    timestamp: number;
}

const ActivityFeed: React.FC = () => {
    const { t } = useTranslation();
    const [currentActivity, setCurrentActivity] = useState<Activity | null>(null);
    const [isVisible, setIsVisible] = useState(false);
    const { location } = useContext(AppContext);

    useEffect(() => {
        // Show first notification after 5-10 seconds
        const firstTimeout = setTimeout(() => {
            showNotification();
        }, Math.random() * 5000 + 5000);

        // Then show notifications every 15-30 seconds
        const interval = setInterval(() => {
            showNotification();
        }, Math.random() * 15000 + 15000);

        return () => {
            clearTimeout(firstTimeout);
            clearInterval(interval);
        };
    }, []);

    const showNotification = () => {
        // Pass user's location and t function to generate more relevant activities
        const activity = generateActivity(location, t);
        setCurrentActivity(activity);
        setIsVisible(true);

        // Auto-hide after 5 seconds
        setTimeout(() => {
            setIsVisible(false);
        }, 5000);
    };

    const handleClose = () => {
        setIsVisible(false);
    };

    if (!currentActivity || !isVisible) return null;

    return (
        <div className="activity-feed position-fixed bottom-0 end-0 m-3" style={{ zIndex: 1050 }}>
            <Alert 
                className="activity-notification bg-body-tertiary shadow-lg border-0 animate-slide-in position-relative"
                style={{ minWidth: '280px' }}
            >
                <button
                    className="btn-close position-absolute top-0 end-0 m-2"
                    aria-label="Close"
                    onClick={handleClose}
                    style={{ width: '0.75rem', height: '0.75rem' }}
                />
                <div className="d-flex align-items-center">
                    <PersonFill className="text-primary me-2" />
                    <div className="pe-3">
                        <div className="fw-bold">
                            {currentActivity.name} {currentActivity.action}
                        </div>
                        <div className="small text-body-secondary d-flex align-items-center">
                            <GeoAltFill size={14} className="me-1" />
                            {currentActivity.city}
                        </div>
                    </div>
                </div>
            </Alert>
        </div>
    );
};

export default ActivityFeed;